import WIDGETS from './widgets';

export default {
	name: 'event_form',
	spacing: 0,
	widgets: [{ content: WIDGETS.EVENT_FORM, breakpoints: { xs: 12 }, component_props: { refTicket: true, bottom_slider_header: true } }],
};
